export default "__VITE_ASSET__Dh4wgVOG__"